import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import WarningIcon from 'ui-library/icons/WarningIcon';

export enum ConfigStatus {
  COMPLETE = 'COMPLETE',
  INVALID = 'INVALID',
}

export interface AnalysisTemplateConfigFrameProps {
  headerTitle: string;
  headerButtons?: React.ReactNode;
  message?: string | null;
  status?: ConfigStatus;
  children?: React.ReactNode;
}

/**
 * Helper component of `AnalysisTemplateInputTableConfig`, to concisely re-use formatting.
 *
 * @package
 */
export default function AnalysisTemplateConfigFrame({
  headerTitle,
  headerButtons,
  message,
  status,
  children,
}: AnalysisTemplateConfigFrameProps): JSX.Element {
  return (
    <div className={css(styles.pane)}>
      <div className={css(styles.header)}>
        <div className={css(styles.headerTitle)}>
          {status && (
            <div className={css(styles.statusIcon)}>
              {status === ConfigStatus.INVALID && <WarningIcon />}
              {status === ConfigStatus.COMPLETE && (
                <BenchlingIcon icon="check-circle" className={css(styles.successIcon)} />
              )}
            </div>
          )}
          {headerTitle}
        </div>
        <div className={css(styles.headerButtons)}>
          <div className={css(styles.message, status === ConfigStatus.INVALID && styles.warningMessage)}>
            {message}
          </div>
          {headerButtons}
        </div>
      </div>
      {children && <div className={css(styles.childPane)}>{children}</div>}
    </div>
  );
}

const styles = StyleSheet.create({
  childPane: {
    marginTop: 16,
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    height: 28,
    justifyContent: 'space-between',
  },
  headerButtons: {
    alignItems: 'center',
    display: 'flex',
    float: 'right',
  },
  headerTitle: {
    ...FONT_PROXIMA_13,
    alignItems: 'center',
    display: 'flex',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  message: {
    fontStyle: 'italic',
    marginRight: 6,
  },
  pane: {
    width: '100%',
  },
  statusIcon: {
    height: 16,
    marginRight: 8,
  },
  successIcon: {
    color: Colors.GREEN_DARK,
    height: 16,
    width: 16,
  },
  warningMessage: {
    color: Colors.ORANGE_DARK,
  },
});
